import { Box, ControlPrefix, FormControlSizes, SearchSelect, useCurrenciesContext } from '@talos/kyoko';
import { ASSET_CONTROL_WIDTH } from './tokens';

interface SignalsCurrencySelectProps {
  /** Talos `Currency.Symbol` strings (e.g. 'BTC', 'ETH'). */
  options: string[];
  value: string | undefined;
  onChange: (symbol: string | undefined) => void;
  disabled?: boolean;
  placeholder?: string;
  /** Optional label shown as an inline prefix before the selected value. */
  prefixLabel?: string;
  /** Width of the trigger button. Defaults to `ASSET_CONTROL_WIDTH`. */
  width?: string;
}

/** Single-select searchable dropdown of Talos currency symbols for driving the active asset. */
export function SignalsCurrencySelect({
  options,
  value,
  onChange,
  disabled,
  placeholder,
  prefixLabel,
  width = ASSET_CONTROL_WIDTH,
}: SignalsCurrencySelectProps) {
  const { currenciesBySymbol } = useCurrenciesContext();

  return (
    <Box w={width} flexShrink={0}>
      <SearchSelect
        w="100%"
        size={FormControlSizes.Small}
        dropdownPlacement="bottom-end"
        selection={value}
        options={options}
        getLabel={item => item}
        getDescription={symbol => currenciesBySymbol.get(symbol)?.Description}
        onChange={onChange}
        portalize
        disabled={disabled}
        placeholder={placeholder}
        prefix={prefixLabel != null ? <ControlPrefix>{prefixLabel}</ControlPrefix> : undefined}
        data-testid="signals-currency-select"
      />
    </Box>
  );
}
